import { ContentWrapper } from '@eti/components';
import { m as motion, AnimatePresence } from 'framer-motion';
import { css, etiColors } from '@eti/styles';
import { CaretUp } from '@phosphor-icons/react';
import { Button } from '@etg/wings';
import { useScrollTo } from '@eti/utils';

const contentButtonWrapper = css`
  bottom: 80px;
  height: 0;
  left: 0;
  pointer-events: none;
  position: fixed;
  right: 0;
  width: 100%;
  z-index: 1;
`;

const moveToUpButtonStyles = css`
  background: ${etiColors.black};
  border-radius: 3px;
  color: #fff;
  height: 48px;
  inset-inline-start: calc(100% - 48px);
  pointer-events: all;
  width: 48px;

  @media (min-width: 1324px) {
    inset-inline-start: calc(100% + 24px);
  }
`;

interface BackToTopButtonProps {
  isVisible: boolean;
}

const BackToTopButton = ({ isVisible }: BackToTopButtonProps) => {
  const { scrollVertical } = useScrollTo();
  const BackToTop = () => scrollVertical('smooth', 0);

  return (
    <ContentWrapper className={contentButtonWrapper}>
      <AnimatePresence>
        {isVisible && (
          <motion.div
            animate={{ opacity: 1 }}
            data-testid="button-wrapper"
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <Button className={moveToUpButtonStyles} onClick={BackToTop}>
              <CaretUp data-testid="up-icon" size={32} />
            </Button>
          </motion.div>
        )}
      </AnimatePresence>
    </ContentWrapper>
  );
};

export default BackToTopButton;
